/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNotesAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M21 2v20H3V2zm-2 2H5v16h14zm-6 4v3h3v2h-3v3h-2v-3H8v-2h3V8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNotesAdd as NotesAdd };
